import {
  BaseVO,
  streamId,
  StreamId,
  streamKind,
  StreamKind
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { MixerId, MixerStreamId } from "../../interface";
import { mixerId, mixerStreamId } from "../../schema";

export class MixerStreamStoppedVO extends BaseVO<MixerStreamStopped> {
  private static validation = JsonSchemaValidator.compile(
    MixerStreamStoppedVO.validationSchema()
  );

  constructor(value: MixerStreamStopped) {
    super(JsonSchemaValidator.assert(MixerStreamStoppedVO.validation, value));
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["mixerId", "streamId", "data"],
      properties: {
        mixerId,
        streamId,
        data: {
          type: "object",
          required: ["streamId", "kind"],
          properties: {
            streamId: mixerStreamId,
            kind: streamKind
          },
          additionalProperties: false
        }
      },
      additionalProperties: false
    };
  }
}

interface MixerStreamStopped {
  mixerId: MixerId;
  streamId: StreamId;
  data: {
    streamId: MixerStreamId;
    kind: StreamKind;
  };
}
